import { CommonEnums } from '../../common.enums';

export class Usr_Cfg {
    usr_Id: number;
    usr_Cfg_Cd: string;
    usr_Cfg_Val: string;
    updateDt: Date;
    updateBy: string;

    constructor() {
        this.usr_Id = CommonEnums.defaults.LONG_VAL;
        this.usr_Cfg_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.usr_Cfg_Val = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
    }

    static parse(usr_CfgTmp: any): Usr_Cfg {
        let usr_Cfg = new Usr_Cfg();
        usr_Cfg.copyFrom(usr_CfgTmp as Usr_Cfg);
        return usr_Cfg;
    }

    copy(): Usr_Cfg {
        let usr_CfgTmp = new Usr_Cfg();

        usr_CfgTmp.usr_Id = this.usr_Id;
        usr_CfgTmp.usr_Cfg_Cd = this.usr_Cfg_Cd;
        usr_CfgTmp.usr_Cfg_Val = this.usr_Cfg_Val;
        usr_CfgTmp.updateBy = this.updateBy;
        usr_CfgTmp.updateDt = this.updateDt;

        return usr_CfgTmp;
    }

    copyFrom(usr_CfgTmp: Usr_Cfg): void {
        this.usr_Id = usr_CfgTmp.usr_Id;
        this.usr_Cfg_Cd = usr_CfgTmp.usr_Cfg_Cd;
        this.usr_Cfg_Val = usr_CfgTmp.usr_Cfg_Val;
        this.updateBy = usr_CfgTmp.updateBy;
        this.updateDt = usr_CfgTmp.updateDt;
    }

    compare(usr_CfgTmp: Usr_Cfg): string {
		let usr_CfgString: string = this.toString();
		let usr_CfgTmpString: string = usr_CfgTmp.toString();

		if (usr_CfgString != usr_CfgTmpString) {
			return usr_CfgString + ', ' + usr_CfgTmpString;
		}

		return '';
	}

	toString(): string {
		let str: string = "usr_Cfg [usr_Id=" + this.usr_Id + ", usr_Cfg_Cd=" + this.usr_Cfg_Cd + ", usr_Cfg_Val=" + this.usr_Cfg_Val +
			", updateBy=" + this.updateBy + ", updateDt=" + this.updateDt + ']';
		return str;
	}
}